module.exports = __webpack_public_path__ + "media/customizations/windsong/back-a42088ccea7fd502812ca73f53cc07e4.jpg";